// extracted by mini-css-extract-plugin
export default {"formAdd":"styles_formAdd__BKEJG","formItem":"styles_formItem__kUWKR","formFull":"styles_formFull__itIof","InputNumber":"styles_InputNumber__E0vQl"};